import { render, staticRenderFns } from "./OurWork.vue?vue&type=template&id=16171817&"
import script from "./OurWork.vue?vue&type=script&lang=js&"
export * from "./OurWork.vue?vue&type=script&lang=js&"
import style0 from "./OurWork.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports